import { render, staticRenderFns } from "./CanalsModal.vue?vue&type=template&id=8c5dff28&scoped=true"
import script from "./CanalsModal.vue?vue&type=script&lang=js"
export * from "./CanalsModal.vue?vue&type=script&lang=js"
import style0 from "./CanalsModal.vue?vue&type=style&index=0&id=8c5dff28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5dff28",
  null
  
)

export default component.exports